<template>
  <section>
    <div class="section_title">
      <img src="@/assets/img/settings_sub.jpg" />
      <h1 class="">メールアドレス変更</h1>
    </div>
    <div class="detail-cart text-center my-5 border box-p-20">
      <p>
        現在登録中のメールアドレス：<span>{{ currentMailAddress }}</span>
      </p>
      <h2 class="mb-2">
        新しいメールアドレスを入力してください <br />（半角英数字で入力）
      </h2>
      <p class="mb-2">
        <input v-model="newMailAddress" type="email" maxlength="50" ref="newMailAddress" />
      </p>
      <p>
        「メールアドレスを変更する」ボタンを押すと確認メールが送信されます。
        <br />メールが来ない場合は、メールアドレスが間違っているか、迷惑メールフォルダに分類されている可能性があります。
        <br />メールアドレスが間違っていた場合は、大変お手数ですが再度このページより正しいメールアドレスを入力して
        <br />「メールアドレスを変更する」ボタンを押してください。
      </p>
    </div>
    <div class="my-5 text-center">
      <button v-on:click="changeMailAddress" class="btn d-inline-block">
        メールアドレスを変更する
      </button>
    </div>
    <div class="mb-5 text-center">
      <router-link to="/settings" class="btn d-inline-block"
        >会員情報を変更へ戻る</router-link
      >
    </div>
  </section>
</template>

<style scoped>
  @media screen and (min-width: 700px)  {
      .detail-cart input[type="email"] {
          width: 70%;
      }
  }
</style>

<script>
import Request from "@/modules/Request";
import Message from "@/modules/Message";
import Authenticate from "@/modules/Authenticate";
let auth = new Authenticate();
let request = new Request();

export default {
  data() {
    return {
      currentMailAddress: "",
      newMailAddress: "",
    };
  },
  mounted() {
    this.getCurrentMailAdress();
    window.scroll(0, 0);
  },
  methods: {
    getCurrentMailAdress() {
      let requestParams = request.createParams(
        "webMdlMemberInfo",
        "getMailAddress",
        []
      );
      request
        .create()
        .post("", requestParams)
        .then((data) => {
          this.currentMailAddress = data.CurrentMailAddress;
        });
    },
    changeMailAddress() {

      // 入力チェック
      if (this.newMailAddress == "") {
        Message.error().fire({
          title: "メールアドレスが入力されていません",
          didClose: () => {
            this.$refs.newMailAddress.focus();
          }
        });
        return;
      }
      if (!/^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(this.newMailAddress)) {
        Message.error().fire({
          title: "メールアドレスの形式に誤りがあります",
          didClose: () => {
            this.$refs.newMailAddress.focus();
          }
        });
        return;
      }

      Message.confirm()
        .fire({
          title: "下記内容で変更します。よろしいですか？",
          html:
            "旧アドレス：" +
            this.currentMailAddress +
            "<br>" +
            "新アドレス：" +
            this.newMailAddress,
        })
        .then((result) => {
          if (result.isConfirmed) {
            //メールアドレス変更の処理
            let postParams = [this.newMailAddress];
            let requestParams = request.createParams(
              "webMdlMemberInfo",
              "putMailAddress",
              postParams
            );
            request
              .create()
              .post("", requestParams)
              .then((data) => {
                Message.success().fire({
                  position: 'center',
                  showConfirmButton : true,
                  timer : null,
                  toast: false,
                  title: data.msg,
                });
                auth.logout();
              });
          }
        });
    },
  },
};
</script>